import { SalesTaxFlow, TSalesTaxFlow } from '@commenda/types';

/**
 * What a SERVICE_CATALOG link can name: a sales-tax flow, which runs the workflow linked to it whatever its request's
 * service. A request's kind follows from its filing and service, so no workflow is found by it; link those workflows
 * to their Commenda service or compliance type instead.
 */
export const getServiceCatalogTypesForWorkflows = (): TSalesTaxFlow[] =>
  Object.values(SalesTaxFlow);
